import { getPricingConfig } from '@constants'

export default ({ store, app, $config }, inject) => {
  // update subscription pricing based on current locale
  const updateSubscriptionPricing = (locale) => {
    const pricing = getPricingConfig($config)
    store.set('subscription/plusOption', locale === 'en' ? pricing.PLUS_YEAR.idEN : pricing.PLUS_YEAR.idNL)
    store.set('subscription/premiumOption', locale === 'en' ? pricing.PREMIUM_YEAR.idEN : pricing.PREMIUM_YEAR.idNL)
  }

  // set initial pricing on page load
  if (process.client) {
    app.i18n.onLanguageSwitched = (oldLocale, newLocale) => {
      updateSubscriptionPricing(newLocale)
      store.set('language/locale', newLocale)
    }

    // set initial pricing after nuxt is ready
    window.onNuxtReady(() => {
      updateSubscriptionPricing(app.i18n.locale)
    })
  }
}
